export default {
    100: "#ECF1FD",

    200: "#DBE3FA",

    250: "rgba(201, 215, 255, 0.5)",

    300: "#C9D7FF",

    400: "#B8C7F6",

    500: "#9AB3FF",

    600: "#6686FF",

    main: "#6181EA",

    800: "#466EF1",

    900: "#2E4FBD",
};
